export enum SectionTypeToFilter {
  HEADER = 'Header',
  FOOTER = 'Footer',
}

export const legalPagesToFilterSet = new Set([
  'privacy policy',
  'shipping policy',
  'return policy',
  'refund policy',
  'accessibility statement',
  'terms & conditions',
]);

export const GENERATE_FULL_SITE_MAP =
  '/_serverless/studio-sitemap/generate-full-classic-editor';
export const SECTION_LABEL_MAPPING =
  '/_serverless/studio-sitemap/section-mapping-classic-editor';
